import React from "react";
import { BackgroundImage, HighEquipments, HomeAbout, OurApproach,HomeExperience } from "../../ThirdComponents";


const ThirdAbout = (props) => {
    const { selectedLanguage } = props
    return (
        <div>
            <BackgroundImage {...props} heading={selectedLanguage?.txt_about_us} mainClass='third-design-about-banner' />
            <HomeAbout {...props}/>
            <HomeExperience {...props}/>
            <HighEquipments {...props}/>
            <OurApproach {...props}/>
        </div>
    )
}

export default ThirdAbout